const resizeImage = (img: any, blobCallback?: any ) => {
    var max_width = 800;
    var max_height = 800;
    const IMAGE_QUALITY: Number = 1;
    var canvas: any = document.createElement('canvas');
  
    var width = img.width;
    var height = img.height;
  
    // calculate the width and height, constraining the proportions
    if (width > height) 
    
    {
      if (width > max_width) 
      {
        height = Math.round(height *= max_width / width);
        width = max_width;
      }
    } 
    else 
    {
      if (height > max_height) 
      {
        width = Math.round(width *= max_height / height);
        height = max_height;
      }
    }
    // resize the canvas and draw the image data into it
    canvas.width = width;
    canvas.height = height;
    var ctx: any = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);

    if(blobCallback) {
        canvas.toBlob(blobCallback, 'image/jpeg', IMAGE_QUALITY);
    }

    return canvas.toDataURL("image/jpeg", IMAGE_QUALITY);
}

export default resizeImage;
